import React from 'react';

import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import './EmptyCard.scss';

type Props = {
    title: string;
    icon?: RichIconTypes;
} & React.PropsWithChildren;

const EmptyCard: React.FC<Props> = ({ title, children, icon = RichIconTypes.UNDRENDE }) => {
    return (
        <div className="empty-card">
            <RichIcon type={icon} />

            <h3 className="empty-card__title typography-h3">{title}</h3>
            {children}
        </div>
    );
};

export default EmptyCard;
